import styled, { css } from "styled-components";
import {
  Section as SectionStyles,
  BtnFlex,
  Btn,
  BtnLink,
  BtnSmall,
  Container as ContainerStyles,
  Grid,
  SectionSubTitle,
  SectionTitle,
} from "../ReUsableStyles";
import { Link } from "react-router-dom";

// ====make carousel====
// import Slide from "react-reveal/Slide";

export const Section = styled.section`
  ${SectionStyles};
`;
export const Title = styled.h2`
  ${SectionTitle};
`;
export const Subtitle = styled.span`
  ${SectionSubTitle};
`;

export const Container = styled.div`
    ${ContainerStyles};
    margin:0;
    display:flex;
    justify-content:center;
    position:relative;
    overflow: hidden;
    padding-bottom: var(--mb-2-5);
`;
export const CarouselContainer = styled.div`
    width:100%;
    display:flex;
    transition: all 1.5s ease;
    transform: translateX(${props => props.slideIndex * -100}vw);

    .ContentWrapper{
      width:100vw;
      // padding: 0 var(--mb-0-5);
    }
`;

export const Content = styled.div`
    width:100vw;
    ${Grid};
    padding: 0 1.5rem;
`;

export const ContentImg = styled.img`
  width: 265px;
  height: 150px;
  object-fit:cover;
  border-radius: 0.5rem;
  justify-self: center;
`;

export const Data = styled.div`
    // width:100vw;
    // display: flex;
    // flex-direction:column;
    // justify-content: flex-start;
    // align-items:flex-start;

`;

export const PortfolioTitle = styled.h3`
  font-size: var(--h3-font-size);
  margin-bottom: var(--mb-0-5);
`;

export const Desc = styled.p`
  width:auto;
  margin-bottom: var(--mb-0-75);
`;

export const SlideArrow = styled.div`
    width: 35px;
    height:35px;
    position:absolute;
    color: white;//var(--first-color);
    border-radius: 50%;
    display:flex;
    align-items:center;
    justify-content: center;
    bottom:0;
    ${props=>props.right? css`right: 0;`:css`left: 0;`};
    margin:auto;
    background-color: rgba(0,0,0,0.3);
    cursor:pointer;
    z-index: 2;
`;

export const DotsWrapper = styled.div`
    position:absolute;
    bottom:0;
    display:flex;
    right:calc(100vw - );
`;

export const Dots = styled.span`
    width: 15px;
    height:15px;
    border-radius:50%;
    margin-right: 5px;
    cursor:pointer;
    ${props=>props.slideIndex === props.index - 1 ?
        css`
            background-color:var(--first-color);
        `:css`
            border: 1px solid var(--first-color);
        `};
`;

export const Button = styled(Link)`
  ${Btn};
  ${BtnFlex};
  ${BtnSmall};
  margin-left:35%;
  &:hover {
    .btn__icon {
      transform: translateX(0.25rem);
    }
  }
`;
